import pako from 'pako'

import PurchasedProduct from '@models/PurchasedProduct'
import Title from '@models/Title'
import { ApiRoutes } from '@utils/api-routes'
import { binStringToBuf } from '@utils/formatters/string.formatter'
import http from '@utils/http'

export default class TitleService {
  static async addFavorite(uuid: string): Promise<boolean> {
    const [resp] = await http.post(ApiRoutes.apiAddFavoriteTitlePath(), {
      uuid,
    })
    return !!resp
  }

  static async removeFavorite(uuid: string): Promise<boolean> {
    const [resp] = await http.post(ApiRoutes.apiRemoveFavoriteTitlePath(), {
      uuid,
    })
    return !!resp
  }

  static toggleFavorite(title: Title): Promise<boolean> {
    return title.favorited
      ? TitleService.removeFavorite(title.uuid)
      : TitleService.addFavorite(title.uuid)
  }

  static async getProductPreview(url: string): Promise<any | null> {
    const [resp, err] = await http.get(url)
    if (err) console.error('Error getting product preview', err)
    if (err || !resp?.data) return null

    const textBuf = binStringToBuf(resp.data)
    return JSON.parse(pako.inflate(textBuf, { to: 'string' }))
  }

  static async fetchPrivateCollectionsForTitle(uuid: string): Promise<number[]> {
    const [resp] = await http.get(ApiRoutes.apiTitlePrivateCollectionsPath(uuid))
    if (!resp?.data) return []
    return resp.data
  }

  static async getPurchasedProduct(uuid: string): Promise<PurchasedProduct | null> {
    // we may attempt to fetch a purchased product after a purchase error to see if the purchase went through,
    // hideGlobalError is set to avoid showing a double error
    const [resp] = await http.get<PurchasedProduct>(ApiRoutes.apiPurchasedProduct(uuid), {
      hideGlobalError: true,
    })
    if (!resp?.data) return null
    return resp.data
  }

  static async createEditableCopy(uuid: string): Promise<null> {
    const [resp, err] = await http.post(ApiRoutes.apiCreateTitleCopy(), {
      title_uuid: uuid,
    })

    if (resp) {
      window.open(resp.data.url, '_blank')
    } else if (err) {
      throw err
    }
    return null
  }
}
